// astro vue will render empty page if import vue from 'vue'
// @ts-ignore
import { createApp } from 'vue/dist/vue.esm-bundler.js'
import hybridPage from '@/lib/hybridPage'
import { GaGeneralPageName } from '@/assets/ts/customEvent'
import { setCurrentGaPageName } from '@/lib/utils'
import MercariDetail from '@/pages/mercari-detail/components/_MercariDetail.vue'

hybridPage()

createApp({
	name: 'Mercari Detail Page',
	components: {
		MercariDetail,
	},
	setup() {
		setCurrentGaPageName(GaGeneralPageName.MercariDetail)

		const { mercariDetailPageContent } = window.pageContent

		return {
			mercariDetailPageContent,
		}
	},
}).mount('#bsMain')
